import { TableContent } from '../../../Common/Table/tableContent';
import React, { useEffect, useState, Fragment, useRef } from "react";
import { TableContentForDairyCollectionDetailedReport } from '../../../Common/Table/tableContent';
import tokenService from '../../../../Common/tokenDecoder';

export default class ComponentToPrint extends React.Component {



    render() {

        const data = this.props.data;
        const rowNames = this.props.rowNames;   
        const searchData = this.props.searchData;
        const densityTotal = this.props.densityTotal;
        const fatTotal = this.props.fatTotal;
        const weightTotal = this.props.weightTotal;


        return (
            <div>
                <h3><center><u>Dairy Collection Detailed Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Factory: </b> {searchData.company}</div>
                    <div className="col"><b>Date: </b> {searchData.date}</div>
                    <div className="col"><b>User: </b> {tokenService.getUserNameFromToken()}</div>
                    <div className="col"><b>Generated Date/Time: </b> {new Date().toLocaleString()}</div>
                </div>
                <div className="row alternative_cls">
                    <div className="col pb-2 width4">
                        <table className="display dataTable no-footer">
                            <thead>
                            <tr>
                              <th rowSpan="2">Name</th>
                              <th rowSpan="2">Reg No</th>
                              <th rowSpan="2">Time</th>
                              <th rowSpan="2">Tag No</th>
                              <th rowSpan="2">Density</th>
                              <th rowSpan="2">Fat</th>
                              <th rowSpan="2">Weight</th>
                            </tr>
                            </thead>
                            <tbody>
                                <TableContentForDairyCollectionDetailedReport
                                    data={data}
                                    contentRowNames={rowNames}
                                    hasEdit={false}
                                />
                            </tbody>
                            <tfoot>

                            <tr>
                              <th colSpan="1">Total</th>
                              <th></th>
                              <th></th>
                              <th></th>
                              <th style={{ textAlign: "right" }}>{densityTotal}</th>
                              <th style={{ textAlign: "right" }}>{fatTotal}</th>
                              <th style={{ textAlign: "right" }}>{weightTotal}</th>
                            </tr>
                            </tfoot>
                        </table>
                    </div>
                    <hr />
                </div>
            </div>
        );
    }
}